/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_BrokersInputs */

const cs_ebr_pairing_brokers = /** @type {(inputs: Ebr_Pairing_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléři ↔ uživatelé CRM`)
};

const en_ebr_pairing_brokers = /** @type {(inputs: Ebr_Pairing_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers ↔ CRM users`)
};

/**
* | output |
* | --- |
* | "Brokers ↔ CRM users" |
*
* @param {Ebr_Pairing_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_brokers = /** @type {((inputs?: Ebr_Pairing_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_brokers(inputs)
	return cs_ebr_pairing_brokers(inputs)
});